import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, Textarea } from '@wayste/sour-ui';
const PostalCodesModal = ({ open, onClose, onSubmit, }) => {
    const [postalCodes, setPostalCodes] = React.useState('');
    const isValid = postalCodes
        .split(',')
        .map((code) => code.trim())
        .reduce((acc, curr) => {
        return acc && curr.length === 5 && Boolean(curr.match(/^[0-9]+$/));
    }, true) && postalCodes.split(',').length > 0;
    const splitForSubmit = postalCodes
        .split(',')
        .map((code) => code.trim())
        .filter((code) => code.length === 5);
    return (_jsx(Dialog, { open: open, onClose: onClose, styledTitle: "Add or cut postal codes", className: "max-w-xl", showX: true, children: _jsxs("div", { className: "flex w-full flex-col", children: [_jsx(Textarea, { label: "Postal Codes", inputProps: {
                        value: postalCodes,
                        onChange: (event) => setPostalCodes(event.target.value),
                    } }), _jsx("p", { className: "text-xs text-gray-500", children: "Enter postal codes separated by commas (e.g. 12345, 12345, 12345)" }), _jsxs("div", { className: "mt-4 flex justify-end gap-4", children: [_jsx("button", { type: "button", className: "btn-dark-grey-outlined", onClick: onClose, children: "Cancel" }), _jsx("button", { type: "button", className: "btn-delete", disabled: !isValid, onClick: () => {
                                onSubmit(splitForSubmit, 'cut');
                                setPostalCodes('');
                                onClose();
                            }, children: "Cut" }), _jsx("button", { type: "button", className: "btn-primary", disabled: !isValid, onClick: () => {
                                onSubmit(splitForSubmit, 'draw');
                                setPostalCodes('');
                                onClose();
                            }, children: "Add" })] })] }) }));
};
export default PostalCodesModal;
//# sourceMappingURL=postal-codes-modal.js.map